import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { ArrowLeft, Share2 } from "lucide-react";
import { themeClass } from "../components/ThemeChip";

export default function History() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/session/history").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="min-h-screen pb-24" data-testid="history-screen">
      <div className="max-w-md mx-auto px-6 pt-8">
        <div className="flex items-center gap-3 mb-7">
          <button onClick={() => nav(-1)} className="p-2 rounded-full hover:bg-white/70" data-testid="history-back">
            <ArrowLeft className="w-5 h-5"/>
          </button>
          <h1 className="font-display text-3xl">Your journey</h1>
        </div>

        {items.length === 0 && (
          <div className="card-soft p-6 text-center text-muted-foreground" data-testid="history-empty">
            Your sessions will appear here every Sunday.
          </div>
        )}

        <div className="space-y-4">
          {items.map((it) => (
            <div key={it.session.id} className={`card-soft p-5 ${themeClass(it.theme?.color_token)}`}
                 data-testid={`history-item-${it.session.id}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="chip theme-surface theme-text">{it.theme?.title} · Week {it.week?.week_number}</span>
                <span className="text-xs text-muted-foreground">
                  {new Date(it.session.completed_at).toLocaleDateString()}
                </span>
              </div>
              <h2 className="font-display text-2xl mb-3">{it.week?.title}</h2>
              {it.session.reflection_answers?.length > 0 && (
                <div className="space-y-2 text-sm">
                  {it.session.reflection_answers.slice(0, 2).map((a, i) => (
                    <div key={i} className="bg-white/60 rounded-2xl p-3">
                      <div className="text-xs text-muted-foreground mb-1">{a.question_text}</div>
                      <div className="italic">"{a.answer_text}"</div>
                    </div>
                  ))}
                </div>
              )}
              {it.share?.variants?.instagram && (
                <button onClick={() => {
                  navigator.clipboard.writeText(it.share.variants.instagram);
                }} className="mt-3 text-xs text-[hsl(var(--neu-orange))] flex items-center gap-1"
                        data-testid={`history-share-${it.session.id}`}>
                  <Share2 className="w-3 h-3"/> Copy share text
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
